export default "<rmd:authenticator>\n\t<div>Hello <span data-id='username'></span>.\n\t(<span data-id='action'></span>)</div>\n</rmd:authenticator>";